import Vue from 'vue';
import { Resolve } from 'vue-di';
import Component from 'vue-class-component';
import styles from '~/assets/style/variables.scss';
import SessionModule from '~/store/session';
import genders, { IGenderObject } from '~/assets/genders';
export default class BaseView extends Vue {
	constructor() {
		super();
	}

	@Resolve
	session!: SessionModule;

	styles = styles;
	isLoading = false;
	genders = genders.filter(x => x.name === 'Male' || x.name === 'Female');

	protected get componentName(): string {
		return this.constructor.name;
	}

	getGenderByAny(value: any): IGenderObject {
		return (
			this.genders.find(
				item => item.id === value || item.code === value || ((item.name || '').toUpperCase() === (String(value) || '').toUpperCase())
			) || {} as IGenderObject
		);
	}
}
